export const addLeadingDot = (path: string) =>
  process.env.STORYBOOK ? `.${path}` : `${path}`;
